import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { ClockIcon } from "@/common/icons/ClockIcon";
import { HomeIcon } from "@/common/icons/HomeIcon";
import { ProfileIcon } from "@/common/icons/ProfileIcon";
import { RouterPath } from "@/router/types";
import { MenuNavLink } from "@/widgets/Layout/Cabinet/ui/MenuNavLink";

export const Navigation: FC = () => {
  return (
    <nav className="bg-light lgc:flex-col lgc:gap-4 flex">
      <MenuNavLink
        to={RouterPath.Cabinet}
        Icon={HomeIcon}
        Title={<FormattedMessage defaultMessage="Главная" />}
      />
      <MenuNavLink
        to={RouterPath.History}
        Icon={ClockIcon}
        Title={<FormattedMessage defaultMessage="История" />}
      />
      <MenuNavLink
        to={RouterPath.Profile}
        Icon={ProfileIcon}
        Title={<FormattedMessage defaultMessage="Анкета" />}
      />
    </nav>
  );
};
